module.exports = __webpack_public_path__ + "img/markfashion.4ec69a45.png";